const ACS_REGION_COOKIE = 'acs_region';
const ACS_REGION_STORAGE_KEY = 'acs_region';
const ACS_REGION_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

function normalizePath(path) {
  try {
    return new URL(path, window.location.origin).pathname.replace(/\/+$/, '') || '/';
  } catch (error) {
    return path;
  }
}

class AcsRegionManager {
  constructor() {
    this.regions = this.readConfig();
    this.currentRegion = this.getStoredRegion();
  }

  readConfig() {
    try {
      return JSON.parse(document.querySelector('#acs-region-config')?.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  getStoredRegion() {
    const cookieRegion = document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith(`${ACS_REGION_COOKIE}=`))
      ?.split('=')[1];
    let localRegion = null;
    try {
      localRegion = window.localStorage.getItem(ACS_REGION_STORAGE_KEY);
    } catch (error) {
      localRegion = null;
    }
    const storedRegion = cookieRegion || localRegion;
    return this.regions.some((region) => region.handle === storedRegion) ? storedRegion : null;
  }

  getRegion(handle = this.currentRegion) {
    return this.regions.find((region) => region.handle === handle) || null;
  }

  setRegion(handle) {
    const region = this.getRegion(handle);
    if (!region) return false;

    this.currentRegion = region.handle;
    document.cookie = `${ACS_REGION_COOKIE}=${encodeURIComponent(region.handle)}; path=/; max-age=${ACS_REGION_COOKIE_MAX_AGE}; SameSite=Lax`;
    try {
      window.localStorage.setItem(ACS_REGION_STORAGE_KEY, region.handle);
    } catch (error) {
      // Cookie storage remains the durable fallback when localStorage is unavailable.
    }
    document.documentElement.dataset.region = region.handle;

    if (typeof publish === 'function') {
      publish('acs-region-changed', { region });
    }

    return true;
  }

  async suggestRegion() {
    if (this.currentRegion) return;

    try {
      const response = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(2000) });
      if (!response.ok) return;
      const location = await response.json();
      const city = String(location.city || '').toLowerCase();
      const match = this.regions.find((region) => city.includes(region.name.toLowerCase()));
      if (match) {
        document.querySelector(`[data-region-handle="${match.handle}"]`)?.setAttribute('data-recommended', 'true');
        const recommendation = document.querySelector('[data-region-recommendation]');
        if (recommendation) {
          recommendation.textContent = `${match.name} wurde als Standort vorgeschlagen.`;
          recommendation.hidden = false;
        }
      }
    } catch (error) {
      // The location suggestion is optional; manual selection remains available.
    }
  }
}

class AcsRegionModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[role="dialog"]');
    this.buttons = [...this.querySelectorAll('[data-region-handle]')];
    this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button.dataset.regionHandle)));

    if (!window.acsRegionManager?.currentRegion) {
      this.show();
      window.acsRegionManager?.suggestRegion();
    }
  }

  show() {
    this.hidden = false;
    this.dialog?.focus();
  }

  select(handle) {
    const regions = window.acsRegionManager?.regions || [];
    const currentPath = normalizePath(window.location.pathname);
    const isHomePage = regions.some(
      (r) => r.homeUrl && normalizePath(r.homeUrl) === currentPath
    );
    const isServicePage = regions.some(
      (r) => r.serviceCollectionUrl && normalizePath(r.serviceCollectionUrl) === currentPath
    );

    if (!window.acsRegionManager?.setRegion(handle)) return;
    this.hidden = true;
    const region = window.acsRegionManager.getRegion();
    applyRegionToHeader(region);

    if (isHomePage && region?.homeUrl) {
      window.location.assign(region.homeUrl);
    } else if (isServicePage && region?.serviceCollectionUrl) {
      window.location.assign(region.serviceCollectionUrl);
    }
  }
}

class AcsRegionSwitcher extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-acs-region-open]');
    this.trigger?.addEventListener('click', () => {
      document.querySelector('acs-region-modal')?.removeAttribute('hidden');
    });
  }
}

function applyRegionToUtilityBar(region) {
  if (!region) return;

  const regionName = document.querySelector('[data-acs-region-name]');
  if (regionName) {
    regionName.textContent = region.name || '';
  }

  const addressContainer = document.querySelector('#acs-region-address');
  const addressLink = addressContainer?.querySelector('a');
  if (addressContainer && addressLink) {
    if (region.address) {
      addressLink.textContent = region.address;
      addressLink.hidden = false;
      addressContainer.hidden = false;

      if (region.addressUrl) {
        addressLink.href = region.addressUrl;
      } else {
        addressLink.removeAttribute('href');
      }
    } else {
      addressContainer.hidden = true;
    }
  }

  const phoneContainer = document.querySelector('#acs-region-phone');
  const phoneLink = phoneContainer?.querySelector('a');
  if (phoneContainer && phoneLink) {
    if (region.phone) {
      phoneLink.textContent = region.phone;
      phoneLink.href = `tel:${region.phone.replace(/[^\d+]/g, '')}`;
      phoneContainer.hidden = false;
    } else {
      phoneContainer.hidden = true;
    }
  }

  const emailContainer = document.querySelector('#acs-region-email');
  const emailLink = emailContainer?.querySelector('a');
  if (emailContainer && emailLink) {
    if (region.email) {
      emailLink.textContent = region.email;
      emailLink.href = `mailto:${region.email}`;
      emailContainer.hidden = false;
    } else {
      emailContainer.hidden = true;
    }
  }
  document.documentElement.dataset.acsRegionReady = 'true';
}

 
  


function applyRegionToHeader(region) {
  if (!region) return;

  applyRegionToUtilityBar(region);

  const currentLabel = document.querySelector('[data-acs-region-current]');
  if (currentLabel) currentLabel.textContent = region.name;

  document.querySelectorAll('[data-acs-region-home]').forEach((link) => {
    link.setAttribute('href', region.homeUrl || '/');
  });

  /*
  if (region.logoUrl) {
    document.querySelectorAll('[data-acs-region-logo]').forEach((img) => {
      img.src = region.logoUrl;
      img.srcset = region.logoUrl;
      if (region.logoAlt) img.alt = region.logoAlt;
    });
  }
  */

  
  if (Array.isArray(region.menu) && region.menu.length > 0) {
    const menuLists = document.querySelectorAll(
      '.header__inline-menu > ul, .header__inline-menu .list-menu--inline'
    );
    menuLists.forEach((list) => {
      list.innerHTML = region.menu
      .map((item, index) => {
        const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
        const itemPath =
          new URL(item.url, window.location.origin).pathname.replace(/\/+$/, '') || '/';
        const isCurrent = itemPath === currentPath;

        return `
          <li>
            <a
              id="HeaderMenu-${item.handle || index}"
              href="${item.url}"
              class="tw-no-underline tw-mr-2 hover:tw-no-underline"
              ${isCurrent ? 'aria-current="page"' : ''}
            >
              <span class="header__menu-item${isCurrent ? ' header__active-menu-item' : ''}">
                <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1" aria-hidden="true">
                  ${item.icon || ''}
                </span>
                ${item.title}
              </span>
            </a>
          </li>
        `;
      })
      .join('');
    });
  }
  
  
  
  
  
}

document.addEventListener('DOMContentLoaded', () => {
  const region = window.acsRegionManager?.getRegion();
  if (!region) return;

  applyRegionToHeader(region);

  // Bölge zaten seçiliyse ve kullanıcı kök adrese geldiyse bölge ana sayfasına yönlendir.
  const isRootPath = window.location.pathname === '/' || window.location.pathname === '';
  if (isRootPath && region.homeUrl) {
    window.location.replace(region.homeUrl);
  }
});

window.acsRegionManager = new AcsRegionManager();

if (!customElements.get('acs-region-modal')) {
  customElements.define('acs-region-modal', AcsRegionModal);
}

if (!customElements.get('acs-region-switcher')) {
  customElements.define('acs-region-switcher', AcsRegionSwitcher);
}